import { types } from 'mobx-state-tree';
import OrderStore from "@stores/OrderStore";
import Account from '@stores/Account';  //ok
import Navigation from '@stores/Navigation';
import SearchStore from '@stores/SearchStore'; // ok
import Reports from '@stores/Reports'; // ok
import Analytics from '@stores/Analytics'; // ok
import Beriksson from '@stores/Beriksson';

export default types.model('RootStore',
    {
        navigation: Navigation,
        account: types.optional(Account, {}),
        order: types.optional(OrderStore, {}),
        search: types.optional(SearchStore, {}),
        reports: types.optional(Reports, {}),
        analytics: types.optional(Analytics, {}), 
        beriksson: types.optional(Beriksson, {})
        
    })
    .views((self) => ({ 
    }))
    .actions((self) => {

        const disposables = [];
        return {
            afterCreate() { 

                //self.account.getAccount().then(() => {
                //    //
                //});
                //self.activateUrlAndCustomerListener
            },

        }
    }); 



